import React from "react";

const emptyAchievement = { title: "", year: "", description: "" };
const emptyTimelineEntry = { year: "", title: "", description: "" };

export default function PoliticalAchievementsTab({ achievements, setAchievements, timeline, setTimeline }) {
    const updList = (list, setList, i, key, val) => {
        const c = [...list];
        c[i] = { ...c[i], [key]: val };
        setList(c);
    };

    const removeAt = (list, setList, i) => setList(list.filter((_, idx) => idx !== i));

    return (
        <div>
            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold d-flex justify-content-between align-items-center">
                    <span>Key Achievements</span>
                    <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => setAchievements([...achievements, { ...emptyAchievement }])}
                    >
                        <i className="bi bi-plus-lg me-1" />
                        Add Achievement
                    </button>
                </div>
                <div className="card-body">
                    {achievements.length === 0 ? (
                        <p className="text-muted mb-0">No achievements added yet.</p>
                    ) : (
                        <>
                            {achievements.map((a, i) => (
                                <div className="row g-2 align-items-start mb-3 pb-3 border-bottom" key={i}>
                                    <div className="col-md-2">
                                        <label className="form-label small text-muted">Year</label>
                                        <input
                                            className="form-control form-control-sm"
                                            placeholder="2020"
                                            value={a.year}
                                            onChange={(e) => updList(achievements, setAchievements, i, "year", e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label small text-muted">Title</label>
                                        <input
                                            className="form-control form-control-sm"
                                            placeholder="Achievement title"
                                            value={a.title}
                                            onChange={(e) => updList(achievements, setAchievements, i, "title", e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-5">
                                        <label className="form-label small text-muted">Description</label>
                                        <input
                                            className="form-control form-control-sm"
                                            placeholder="Details about this achievement"
                                            value={a.description}
                                            onChange={(e) => updList(achievements, setAchievements, i, "description", e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-1 d-flex align-items-end">
                                        <button
                                            className="btn btn-sm btn-outline-danger w-100"
                                            onClick={() => removeAt(achievements, setAchievements, i)}
                                        >
                                            <i className="bi bi-trash" />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </>
                    )}
                </div>
            </div>

            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold d-flex justify-content-between align-items-center">
                    <span>Career Timeline</span>
                    <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => setTimeline([...timeline, { ...emptyTimelineEntry }])}
                    >
                        <i className="bi bi-plus-lg me-1" />
                        Add Event
                    </button>
                </div>
                <div className="card-body">
                    {timeline.length === 0 ? (
                        <p className="text-muted mb-0">No timeline events added yet.</p>
                    ) : (
                        <>
                            {timeline.map((t, i) => (
                                <div className="row g-2 align-items-start mb-3 pb-3 border-bottom" key={i}>
                                    <div className="col-md-2">
                                        <label className="form-label small text-muted">Year</label>
                                        <input
                                            className="form-control form-control-sm"
                                            placeholder="2015"
                                            value={t.year}
                                            onChange={(e) => updList(timeline, setTimeline, i, "year", e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label small text-muted">Event Title</label>
                                        <input
                                            className="form-control form-control-sm"
                                            placeholder="e.g. Elected to Parliament"
                                            value={t.title}
                                            onChange={(e) => updList(timeline, setTimeline, i, "title", e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-5">
                                        <label className="form-label small text-muted">Description</label>
                                        <input
                                            className="form-control form-control-sm"
                                            placeholder="Details about this event"
                                            value={t.description}
                                            onChange={(e) => updList(timeline, setTimeline, i, "description", e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-1 d-flex align-items-end">
                                        <button
                                            className="btn btn-sm btn-outline-danger w-100"
                                            onClick={() => removeAt(timeline, setTimeline, i)}
                                        >
                                            <i className="bi bi-trash" />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}